export default __webpack_public_path__ + "static/media/Exterior (6).21e995dc.jpg";